import React from 'react';

const NewConfigModal = ({ 
  isOpen, 
  configName, 
  onConfigNameChange, 
  onClose, 
  onCreate, 
  isLoading 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 backdrop-blur-sm flex items-center justify-center z-50 p-4 backdrop-blur-sm">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">Create New Configuration</h2>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="configName">
            Configuration Name (Use Case)
          </label>
          <input
            id="configName"
            type="text"
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder="e.g., wealth_management"
            value={configName}
            onChange={(e) => onConfigNameChange(e.target.value)}
          />
          <p className="text-gray-500 text-xs mt-1">
            This will be used as the use_case parameter in API calls.
          </p>
        </div>
        <div className="flex justify-end space-x-2">
          <button
            className="h-[34px] px-3 py-1.5 text-[13px] font-medium bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-lg"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="h-[34px] px-3 py-1.5 text-[13px] font-medium bg-secondary hover:bg-secondaryDark text-white rounded-lg"
            onClick={onCreate}
            disabled={!configName.trim() || isLoading}
          >
            {isLoading ? (
              <div className="flex items-center">
                <div className="w-3 h-3 border-2 border-t-white border-white border-opacity-20 rounded-full animate-spin mr-2"></div>
                Creating...
              </div>
            ) : (
              'Create'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewConfigModal;